import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Color from '../../../core/libraries/Color';
import RbLabel from '../../../bosch-react/components/label/RbLabel';
import RbButton, { ButtonSize } from '../../../bosch-react/components/button/RbButton';
import { Icon } from '@fluentui/react';

interface AlreadyRequestedPageProps {
    history: any;
}

class AlreadyRequestedPage extends React.Component<AlreadyRequestedPageProps> {

    constructor(props: AlreadyRequestedPageProps) {
        super(props);
        this.goToPendingOrders = this.goToPendingOrders.bind(this);
    }

    goToPendingOrders() {
        this.props.history.push(process.env.REACT_APP_MY_PENDING_ORDERS || "/");
    }

    render() {
        return (
            <div className="ms-Grid" style={{ 
                minHeight: '70vh', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
            }}>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12" style={{ textAlign: 'center' }}>
                        <div style={{
                            background: 'white',
                            borderRadius: '12px',
                            padding: '60px 40px',
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                            maxWidth: '600px',
                            margin: '0 auto'
                        }}>
                            {/* Icon */}
                            <div style={{ marginBottom: '30px' }}>
                                <Icon 
                                    iconName="Clock" 
                                    style={{ 
                                        fontSize: '64px', 
                                        color: Color.BLUE,
                                        marginBottom: '20px'
                                    }} 
                                />
                            </div>

                            {/* Main Title */}
                            <div style={{ marginBottom: '24px' }}>
                                <RbLabel style={{ 
                                    fontSize: '28px', 
                                    fontWeight: '600',
                                    color: '#323130',
                                    lineHeight: '1.3'
                                }}>
                                    Request Already Submitted
                                </RbLabel>
                            </div>

                            {/* Message */}
                            <div style={{ marginBottom: '32px' }}>
                                <RbLabel style={{ 
                                    fontSize: '18px',
                                    color: '#605e5c',
                                    lineHeight: '1.5',
                                    maxWidth: '480px',
                                    margin: '0 auto',
                                    display: 'block'
                                }}>
                                    You have already requested permission for this document. 
                                    Please wait for approval from the designated approver.
                                </RbLabel>
                            </div>

                            {/* Additional Info */}
                            <div style={{ 
                                marginBottom: '40px',
                                padding: '20px',
                                backgroundColor: '#f3f2f1',
                                borderRadius: '8px',
                                border: `2px solid ${Color.BLUE}20`
                            }}>
                                <Icon 
                                    iconName="Info" 
                                    style={{ 
                                        fontSize: '16px', 
                                        color: Color.BLUE,
                                        marginRight: '8px'
                                    }} 
                                />
                                <RbLabel style={{ 
                                    fontSize: '14px',
                                    color: '#605e5c',
                                    display: 'inline'
                                }}>
                                    You can track the status of your request in the "My Pending Orders" section.
                                </RbLabel>
                            </div>

                            {/* Action Buttons */}
                            <div style={{ 
                                display: 'flex', 
                                gap: '16px', 
                                justifyContent: 'center',
                                flexWrap: 'wrap'
                            }}>
                                <RbButton 
                                    label="View My Pending Orders" 
                                    size={ButtonSize.Standard}
                                    onClick={this.goToPendingOrders}
                                    style={{
                                        minWidth: '200px',
                                        backgroundColor: Color.BLUE,
                                        borderColor: Color.BLUE
                                    }}
                                />
                            </div>

                            {/* Footer note */}
                            <div style={{ marginTop: '32px', paddingTop: '24px', borderTop: '1px solid #edebe9' }}>
                                <RbLabel style={{ 
                                    fontSize: '12px',
                                    color: '#a19f9d',
                                    fontStyle: 'italic'
                                }}>
                                    Need help? Contact support for assistance with your request.
                                </RbLabel>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(connect()(AlreadyRequestedPage));